import React from 'react';

import { DetailedRaceEvent, RaceMarket, RacingCombinations } from '../../../interfaces/RacingState';

export interface RacingDetailContextProps {
  event: DetailedRaceEvent,
  selectedMarket: RaceMarket,
  setSelectedMarket: Function,
  order: 'asc' | 'desc',
  setOrder: Function
  orderBy: string,
  setOrderBy: Function,
  selectedSelectionType: string,
  setSelectedSelectionType:Function,
  selectedHorsePosition: number[][],
  setSelectedHorsePosition: Function,
  combinations: RacingCombinations,
  setCombinations: Function,
  quickBet:boolean,
  setQuickBet: Function,
  showCompetitors: { show: boolean, open: number, total: number },
  setShowCompetitors: Function,
  isValidForQuickBet: boolean,
  setIsValidForQuickBet: Function,
  hideDetail: boolean,
  official: boolean,
  setOfficial: Function,
  podiumNr: number,
  setPodiumNr: Function
}

const RacingDetailContext = React.createContext<Partial<RacingDetailContextProps>>({
  event: null,
  selectedMarket: {
    code: '0',
    name: '',
    marketCode: '1',
    outcomes: [], oddsType:3,
    genericName:'FO',
    statusNumber: 1,
    statusName: 'active',
    crossEvents: [],
    typeCode: 0,
    predictionCount:1,
    isScratchedSelectable: false
  },
  setSelectedMarket: () => {},
  order: 'asc',
  setOrder: () => {},
  orderBy: '',
  setOrderBy: () => {},
  selectedSelectionType: 'singlePerm',
  setSelectedSelectionType: () => {},
  selectedHorsePosition: [],
  setSelectedHorsePosition: () => {},
  setCombinations: () => {},
  combinations: {
    odds: 0,
    rankedNumbers: [],
    repetitionsCount: 0,
    prediction: {
      maximumReturn: 0,
      minimumReturn: 0,
      permutationsCount:0,
      permutations2: {
        numbers: [],
        bonus: [],
        odds: 0,
        stake: 0
      }
    },
    anyNumbers: [],
    permutationsCount: 0,
    permutations: [],
    maximumProfit: 0,
    numbersToPredictCount: 0
  },
  showCompetitors: { show: false, open: 0, total: 0 },
  setShowCompetitors: () => {},
  quickBet: false,
  setQuickBet: () => {},
  isValidForQuickBet:false,
  setIsValidForQuickBet: () => {},
  hideDetail: false,
  official: false,
  setOfficial: () => {},
  podiumNr: 0,
  setPodiumNr: () => {}
});

export default RacingDetailContext;
